<template>
  <div id="my-app">
    <AppNav />

    <div id="main">
      <router-view></router-view>
    </div>

    <AppFooter />

    <!-- Scroll to top button -->
    <transition name="scroll-top">
      <button
        v-if="showScrollTop"
        class="scroll-top-btn"
        @click="scrollToTop"
        aria-label="Lên đầu trang"
      >
        <i class="fas fa-chevron-up"></i>
      </button>
    </transition>
  </div>
</template>

<script>
import AppNav    from '@/components/navigation/AppNav.vue';
import AppFooter from '@/components/footer/AppFooter.vue';

export default {
  name: 'AppLayout',
  components: { AppNav, AppFooter },

  data() {
    return {
      showScrollTop: false,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.showScrollTop = window.scrollY > 400;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style src="./AppLayout.scss" lang="scss"></style>
